import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-center mb-8" }
const _hoisted_2 = { class: "w-100 text-center text-3xl" }
const _hoisted_3 = { class: "phieu-xuat-kho-form-fields" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_7 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_8 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_9 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_10 = {
  key: 2,
  class: "d-flex justify-content-center align-items-center gap-x-1 mt-5"
}

import { computed, onMounted, ref, toValue } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  buildPhieuXuatKhoCreatePayload,
  PhieuXuatKhoSuppliesSection,
  loaiDinhMucFromQuery,
  usePhieuXuatKhoFormMode,
} from "@/components/phieu-xuat-kho";
import type { IPhieuXuatKhoSuppliesQuantityRow } from "@/components/phieu-xuat-kho";
import BaseLink from "@/components/shared/base-link/BaseLink.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import TaiKhoanSelectionV2 from "@/components/shared/tai-khoan-selection/TaiKhoanSelectionV2.vue";
import { LOAI_DINH_MUC } from "@/core/constants/const";
import { getGlobalDefaultDate } from "@/core/config/DatePickerConfig";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import {
  getErrorMsg,
  swalErrNotification,
  swalNotification,
} from "@/core/helpers/utils";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import { useCreatingForm } from "@/core/hooks/use-creating-form";
import useFormInput from "@/core/hooks/use-form-input";
import { useLoading } from "@/core/hooks/use-loading";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import usePhieuXuat from "@/core/hooks/usePhieuXuat";
import useTaiKhoan from "@/core/hooks/useTaiKhoan";
import {
  IBienBanGiaiTheResponseBase,
  IKhoResponseBase,
  IVatTuXuatKhoResponseBase,
  ReceiptBaseResponse,
} from "@/core/interfaces/ApiResponses";
import type { PhieuXuatKhoCreateRequest } from "@/types/phieu-xuat-kho";
import { BienBanGiaiTheService } from "@/core/services/BienBanGiaiThe.service";
import { KhoService } from "@/core/services/Kho.service";
import PhieuXuatKhoService from "@/core/services/Receipt.service";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import ResponsiveLayout from "@/layout/_shared/ResponsiveLayout.vue";
import keys from "lodash/keys";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { replace } = useRouterCustom();

const idBienBan = computed(
  () => Number(route.query.idBienBan) || Number(route.params.idBienBan) || 0
);
const idKhoFromQuery = computed(() => Number(route.query.idKho) || 0);
const idKho = ref(0);
const idPhieuXuat = computed(
  () =>
    Number(
      route.params.idPhieuXuat ?? route.params.idPhieuXuatKho ?? route.params.id
    ) || 0
);

const loaiDinhMuc = ref<LOAI_DINH_MUC>(
  route.query.loaiDinhMuc
    ? loaiDinhMucFromQuery(String(route.query.loaiDinhMuc))
    : LOAI_DINH_MUC.DINH_MUC_CO_DINH
);
const { formConfig, manualPageHeading } = usePhieuXuatKhoFormMode(
  route,
  loaiDinhMuc
);

const isBbgtEdit = computed(
  () => formConfig.value.isBbgt && formConfig.value.mode === "edit"
);

const isFormEdit = computed(() => formConfig.value.mode === "edit");

const isBbgtCreate = computed(
  () => formConfig.value.isBbgt && !isBbgtEdit.value
);

const bbgtIdForForm = computed(() =>
  isBbgtEdit.value
    ? phieuXuatKhoDetail.value?.id_bien_ban_giai_the ?? 0
    : idBienBan.value
);

const bbgtDetailLink = computed(
  () => `/quan-ly/bien-ban-giai-the/chi-tiet/${bbgtIdForForm.value}`
);

const bbgtSoBienBanDisplay = computed(
  () =>
    bienBanDetail.value?.so_bien_ban ??
    phieuXuatKhoDetail.value?.so_bien_ban ??
    ""
);

const FORM_TAB = {
  KHO: 1,
  NGAY: 2,
  NGUOI_NHAN: 3,
  SO_BIEN_BAN: 4,
  LY_DO: 5,
  TK_NO: 6,
} as const;

const isFormFieldDisabled = computed(
  () => formConfig.value.isManual && !editable.value && !isCreating.value
);

const bbgtSelectingKhoId = computed(
  () => suppliesSectionRef.value?.selectingKhoId ?? -1
);

const bbgtKhoOptions = computed(
  () => suppliesSectionRef.value?.khoOptions ?? []
);

const bbgtKhoPlaceholderLabel = computed(
  () => suppliesSectionRef.value?.khoPlaceholderLabel ?? "Chưa chọn kho"
);

const bbgtIsLoadingKho = computed(
  () => suppliesSectionRef.value?.isLoadingKho ?? false
);

const onBbgtKhoSelect = async (idKho: number) => {
  await suppliesSectionRef.value?.handleBbgtKhoChange(idKho);
};

const { isCreating, isDetail, formRef } = useCreatingForm();
const { ButtonsType, ButtonTypeColors } = useButtonCustom();
const { startLoading, endLoading } = useLoading();
const { focusFirstErrInput, focusFirstErrInputV2 } = useFormInput();
const { commit } = useStore();
const { isPhieuXuatEditable, allowEditingTaiKhoan } = usePhieuXuat();
const { onSelectTaiKhoan, clearTaiKhoanData, tkData, setTkData } =
  useTaiKhoan();

const bienBanDetail = ref<IBienBanGiaiTheResponseBase | null>(null);
const khoDetail = ref<IKhoResponseBase | null>(null);
const phieuXuatKhoDetail = ref<ReceiptBaseResponse | null>(null);
const vatTuXuatKhoItems = ref<IVatTuXuatKhoResponseBase[]>([]);
const idKeHoach = ref<number | null>(null);
const suppliesSectionRef = ref<InstanceType<
  typeof PhieuXuatKhoSuppliesSection
> | null>(null);

const form = ref({
  ten_nguoi_nhan: "",
  ly_do: "",
  so_bien_ban: "",
  ngay: getGlobalDefaultDate(),
});

const dateValidation = (
  _: unknown,
  value: unknown,
  callback: (error?: Error) => void
) => {
  if (!value) {
    callback(new Error("Bắt buộc phải nhập ngày xuất"));
    return;
  }

  callback();
};

const rules = computed(() => {
  const base = {
    ten_nguoi_nhan: [
      {
        required: true,
        message: "Phải nhập tên người nhận hàng",
        trigger: "blur",
      },
    ],
    ly_do: [
      { required: true, message: "Phải nhập lý do xuất kho", trigger: "blur" },
    ],
    ngay: [{ validator: dateValidation, trigger: "change" }],
  };

  if (formConfig.value.isBbgt) {
    return base;
  }

  return {
    ...base,
    so_bien_ban: [
      { required: true, message: "Phải nhập số biên bản", trigger: "blur" },
    ],
  };
});

const editable = computed(() =>
  phieuXuatKhoDetail.value
    ? isPhieuXuatEditable(phieuXuatKhoDetail.value)
    : false
);

const editableTaiKhoan = computed(() => {
  const detail = phieuXuatKhoDetail.value;

  return (
    (detail ? allowEditingTaiKhoan(detail) : false) ||
    isCreating.value ||
    editable.value
  );
});

const onVatTuItemsUpdate = (items: IVatTuXuatKhoResponseBase[]) => {
  vatTuXuatKhoItems.value = items;
};

const fetchBbgtEditDetail = async () => {
  await fetchPhieuXuat();
  idKho.value = phieuXuatKhoDetail.value?.id_kho ?? 0;

  if (phieuXuatKhoDetail.value?.id_bien_ban_giai_the) {
    const bbgtId = phieuXuatKhoDetail.value.id_bien_ban_giai_the;

    const {
      data: { data: bienBanData },
    } = await BienBanGiaiTheService.get(bbgtId);

    bienBanDetail.value = bienBanData;
    idKeHoach.value = bienBanData.id_ke_hoach_sua_chua ?? null;

    loaiDinhMuc.value =
      (phieuXuatKhoDetail.value?.loai_dinh_muc ?? 1) === 2
        ? LOAI_DINH_MUC.NGOAI_DINH_MUC
        : LOAI_DINH_MUC.DINH_MUC_CO_DINH;
  }

  setupBbgtEditBreadcrumbs();
  document.title = `${formConfig.value.pageTitle} - Phiếu xuất kho - Đường sắt Hà Nội`;
};

const setupBbgtEditBreadcrumbs = () => {
  setBreadcrumbLinks([
    ...(idKeHoach.value
      ? [
          {
            text: "Kế Hoạch SC",
            routeData: {
              name: "chi-tiet-ke-hoach-sua-chua",
              params: { id: idKeHoach.value },
            },
          },
        ]
      : []),
    {
      text: "BBGT",
      routeData: {
        name: "chi-tiet-bien-ban-giai-the",
        params: {
          id: phieuXuatKhoDetail.value?.id_bien_ban_giai_the ?? 0,
        },
      },
    },
    {
      text: `PXK ${
        loaiDinhMuc.value === LOAI_DINH_MUC.DINH_MUC_CO_DINH
          ? "ĐMCĐ"
          : "Ngoài ĐM"
      }`,
      routeData: {
        name: "chi-tiet-phieu-xuat-kho",
        params: { idPhieuXuatKho: idPhieuXuat.value },
      },
    },
    { text: "Chỉnh sửa" },
  ]);
  setCurrentPageTitle(formConfig.value.pageTitle);
};

const fetchBienBan = async () => {
  const {
    data: { data: bienBanData },
  } = await BienBanGiaiTheService.get(idBienBan.value);

  bienBanDetail.value = bienBanData;
  form.value.ly_do = `Phiếu xuất kho cho toa xe ${
    bienBanDetail.value?.toa_xe.so_hieu
  } - ${
    bienBanDetail.value?.ke_hoach_sua_chua?.cap_sua_chua?.ten_cap_sc ||
    bienBanDetail.value?.cap_sua_chua.ten_cap_sc
  }`;
  form.value.so_bien_ban = bienBanDetail.value?.so_bien_ban ?? "";
};

const fetchKhoDetail = async () => {
  const {
    data: { data: khoResponse },
  } = await KhoService.get(idKho.value);

  khoDetail.value = khoResponse;
  document.title = `${isCreating.value ? "Tạo mới" : "Chỉnh sửa"} - ${
    formConfig.value.documentTitleSuffix
  } - ${khoDetail.value.ten_kho} - Đường sắt Hà Nội`;
};

const fetchPhieuXuat = async () => {
  const {
    data: { data },
  } = await PhieuXuatKhoService.get(idPhieuXuat.value);

  phieuXuatKhoDetail.value = data;
  vatTuXuatKhoItems.value = data.vat_tu_xuat_kho;
  form.value.ten_nguoi_nhan = data.ten_nguoi_nhan ?? "";
  form.value.ly_do = data.ly_do || formConfig.value.defaultLyDo;
  form.value.ngay = data.ngay ? new Date(data.ngay) : getGlobalDefaultDate();
  form.value.so_bien_ban = data.so_bien_ban;

  if (data.tk_no?.ma_tk) setTkData(data.tk_no.ma_tk, "ma_tk");
  if (data.tk_no?.ten_tk) setTkData(data.tk_no.ten_tk, "ten_tk");
  if (data.tk_no?.ma_ct) setTkData(data.tk_no.ma_ct, "ma_ct");
};

const setupBbgtBreadcrumbs = () => {
  setBreadcrumbLinks([
    ...(bienBanDetail.value?.id_ke_hoach_sua_chua
      ? [
          {
            text: "Kế Hoạch SC",
            routeData: {
              name: "chi-tiet-ke-hoach-sua-chua",
              params: { id: bienBanDetail.value.id_ke_hoach_sua_chua },
            },
          },
        ]
      : []),
    {
      text: "BBGT",
      routeData: {
        name: "chi-tiet-bien-ban-giai-the",
        params: { id: idBienBan.value },
      },
    },
    {
      text: `PXK ${
        loaiDinhMuc.value === LOAI_DINH_MUC.DINH_MUC_CO_DINH
          ? "ĐMCĐ"
          : "Ngoài ĐM"
      }`,
    },
  ]);
  setCurrentPageTitle(formConfig.value.pageTitle);
};

const setupManualBreadcrumbs = () => {
  setBreadcrumbLinks([
    {
      text: "Kho",
      routeData: { name: "chi-tiet-kho", params: { id: idKho.value } },
    },
    ...(isCreating.value && !isDetail.value
      ? [{ text: "Phiếu xuất kho" }]
      : []),
    ...(!isCreating.value && !isDetail.value
      ? [
          {
            text: "Phiếu xuất kho",
            routeData: {
              name: "chi-tiet-phieu-xuat-kho",
              params: { idPhieuXuatKho: idPhieuXuat.value },
            },
          },
          { text: "Chỉnh sửa" },
        ]
      : []),
    ...(isDetail.value ? [{ text: "Chi tiết" }] : []),
  ]);
  setCurrentPageTitle(formConfig.value.pageTitle);
};

onMounted(async () => {
  if (formConfig.value.isBbgt) {
    if (isBbgtEdit.value) {
      if (!idPhieuXuat.value) {
        await swalErrNotification(null, "Thiếu tham số phiếu xuất");
        router.back();
        return;
      }

      startLoading();

      try {
        await fetchBbgtEditDetail();
      } catch (error) {
        await swalErrNotification(error, "Lỗi khi lấy thông tin phiếu xuất");
      } finally {
        endLoading();
      }

      return;
    }

    if (!idBienBan.value) {
      await swalErrNotification(null, "Thiếu tham số idBienBan");
      await replace({ name: "danh-sach-bien-ban-giai-the" });
      return;
    }

    loaiDinhMuc.value = loaiDinhMucFromQuery(
      route.query.loaiDinhMuc?.toString()
    );
    startLoading();

    try {
      await fetchBienBan();
      setupBbgtBreadcrumbs();
      document.title = `${formConfig.value.pageTitle} - Phiếu xuất kho - Đường sắt Hà Nội`;
    } catch (error) {
      await swalErrNotification(error, "Có lỗi khi tải dữ liệu phiếu xuất kho");
    } finally {
      endLoading();
    }

    return;
  }

  await startLoading();
  form.value.ly_do = formConfig.value.defaultLyDo;

  if (isCreating.value) {
    idKho.value = Number(route.query.idKho) || Number(route.params.idKho) || 0;

    if (!idKho.value) {
      await swalErrNotification(null, "Thiếu tham số idKho");
      await endLoading();
      router.back();
      return;
    }
  } else if (idPhieuXuat.value) {
    await fetchPhieuXuat();
    idKho.value = phieuXuatKhoDetail.value?.id_kho ?? 0;
  }

  setupManualBreadcrumbs();
  await fetchKhoDetail();
  await endLoading();
});

const getSuppliesQuantityRows = (): IPhieuXuatKhoSuppliesQuantityRow[] =>
  toValue(suppliesSectionRef.value?.quantityRows) ?? [];

const buildSubmitPayload = (): PhieuXuatKhoCreateRequest => {
  suppliesSectionRef.value?.syncVatTuItemsFromQuantityRows?.();

  const quantityRows = getSuppliesQuantityRows();

  if (isBbgtEdit.value) {
    return buildPhieuXuatKhoCreatePayload({
      loaiPhieu: 0,
      idKho: phieuXuatKhoDetail.value?.id_kho ?? 0,
      tenNguoiNhan: form.value.ten_nguoi_nhan,
      lyDo: form.value.ly_do,
      ngay: form.value.ngay,
      quantityRows,
      idBienBan: phieuXuatKhoDetail.value?.id_bien_ban_giai_the,
      loaiDinhMuc: loaiDinhMuc.value,
      soBienBan:
        form.value.so_bien_ban ||
        bienBanDetail.value?.so_bien_ban ||
        phieuXuatKhoDetail.value?.so_bien_ban,
    });
  }

  const idKhoForPayload = formConfig.value.isBbgt
    ? suppliesSectionRef.value?.selectingKhoItem?.id ?? 0
    : idKho.value;

  return buildPhieuXuatKhoCreatePayload({
    loaiPhieu: formConfig.value.loaiPhieu,
    idKho: idKhoForPayload,
    tenNguoiNhan: form.value.ten_nguoi_nhan,
    lyDo: form.value.ly_do,
    ngay: form.value.ngay,
    quantityRows,
    soBienBan: form.value.so_bien_ban,
    ...(formConfig.value.isBbgt
      ? {
          idBienBan: idBienBan.value,
          loaiDinhMuc: loaiDinhMuc.value,
          soBienBan: form.value.so_bien_ban || bienBanDetail.value?.so_bien_ban,
        }
      : {
          maTkNo: String(tkData.value.maTaiKhoan),
          tenTkNo:
            tkData.value.tenTaiKhoan != null
              ? String(tkData.value.tenTaiKhoan)
              : "",
          maCtNo:
            tkData.value.maChiTiet != null
              ? String(tkData.value.maChiTiet)
              : "",
        }),
  });
};

const validateTaiKhoan = async (): Promise<boolean> => {
  if (!tkData.value.maTaiKhoan || !tkData.value.tenTaiKhoan) {
    await focusFirstErrInput("tai-khoan-selection_tai-khoan");
    await swalNotification("Bắt buộc phải nhập mã tài khoản", "error");
    return false;
  }

  return true;
};

const redirectAfterCreate = async (idKhoForCreate: number) => {
  const path =
    formConfig.value.loaiPhieu === 0
      ? `/quan-ly/bien-ban-giai-the/chi-tiet/${idBienBan.value}`
      : `/quan-ly/kho/chi-tiet/${idKhoForCreate}`;

  try {
    await replace(path);
  } catch {
    window.location.assign(path);
  }
};

const handleSubmit = async () => {
  if (!formRef.value) return;

  const isCreate = formConfig.value.mode === "create";

  if (isBbgtEdit.value || (formConfig.value.isBbgt && isCreate)) {
    const suppliesValidation =
      await suppliesSectionRef.value?.validateSupplies();

    if (suppliesValidation === "missing_kho_or_qty" || !suppliesValidation) {
      if (
        suppliesValidation === "missing_kho_or_qty" ||
        suppliesValidation == null
      ) {
        await swalErrNotification(
          null,
          isBbgtEdit.value
            ? "Phải chọn vật tư cho phiếu xuất"
            : "Vui lòng chọn kho và nhập số lượng vật tư xuất"
        );
      }
      return;
    }
  } else if (formConfig.value.isManual) {
    if (!vatTuXuatKhoItems.value.length) {
      await swalErrNotification(null, "Chưa chọn vật tư");
      await suppliesSectionRef.value?.validateSupplies();
      return;
    }

    const isSuppliesReady = await suppliesSectionRef.value?.validateSupplies();

    if (!isSuppliesReady) {
      return;
    }
  }

  if (formConfig.value.showTaiKhoan) {
    if (!(await validateTaiKhoan())) {
      return;
    }
  }

  formRef.value.validate(async (valid, fields) => {
    if (!valid) {
      if (fields) {
        focusFirstErrInput(`${keys(fields)[0]}-input`);
        document.getElementById(`${keys(fields)[0]}-input`)?.scrollIntoView();
      } else {
        await focusFirstErrInputV2();
      }
      return false;
    }

    const confirmMessage = isCreate
      ? formConfig.value.confirmCreateTitle
      : formConfig.value.confirmUpdateTitle;

    commit("ConfirmationDialogModule/setDialog", {
      title: isCreate
        ? "Xác nhận?"
        : `Phiếu xuất số ${phieuXuatKhoDetail.value?.so_phieu ?? ""}`,
      message: confirmMessage,
      confirmButtonText: isCreate ? "Tạo" : "Cập nhật",
      cancelButtonText: "Hủy",
      type: "warning",
      onConfirm: async () => {
        commit("ConfirmationDialogModule/closeDialog");
        await startLoading();

        let createRedirectKhoId: number | null = null;

        try {
          if (isCreate) {
            const payload = buildSubmitPayload();
            const idKhoForCreate = formConfig.value.isBbgt
              ? suppliesSectionRef.value?.selectingKhoItem?.id ?? 0
              : idKho.value;

            await PhieuXuatKhoService.create(payload);
            createRedirectKhoId = idKhoForCreate;
          } else {
            const {
              data: { data },
            } = await PhieuXuatKhoService.update(
              idPhieuXuat.value,
              buildSubmitPayload()
            );

            await swalNotification(
              formConfig.value.submitUpdateMessage,
              "success"
            );
            await replace(`/quan-ly/phieu-xuat-kho/chi-tiet/${data.id}`);
          }
        } catch (err) {
          await swalErrNotification(err, getErrorMsg(err));
        } finally {
          await endLoading();
        }

        if (createRedirectKhoId !== null) {
          await swalNotification(
            formConfig.value.submitCreateMessage,
            "success"
          );
          await redirectAfterCreate(createRedirectKhoId);
        }
      },
    });
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(PageContentBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(manualPageHeading)), 1)
      ]),
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        rules: rules.value,
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (handleSubmit()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(DivRow, { class: "mb-3 g-3" }, {
              default: _withCtx(() => [
                _createVNode(DivCol, {
                  "additional-class": "pb-2",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(LabelCustom, {
                        "is-bolder": _unref(formConfig).isManual,
                        "is-required": isBbgtCreate.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Kho ")
                        ]),
                        _: 1
                      }, 8, ["is-bolder", "is-required"]),
                      (isBbgtCreate.value)
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 0,
                            "model-value": bbgtSelectingKhoId.value,
                            class: "w-100",
                            disabled: bbgtIsLoadingKho.value,
                            loading: bbgtIsLoadingKho.value,
                            name: "id_kho",
                            tabindex: FORM_TAB.KHO,
                            onChange: onBbgtKhoSelect
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                disabled: true,
                                value: -1,
                                label: bbgtKhoPlaceholderLabel.value
                              }, null, 8, ["label"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bbgtKhoOptions.value, (kho) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: kho.id,
                                  label: kho.ten_kho,
                                  value: kho.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["model-value", "disabled", "loading", "tabindex"]))
                        : (isBbgtEdit.value && phieuXuatKhoDetail.value?.kho)
                          ? (_openBlock(), _createBlock(BaseLink, {
                              key: 1,
                              to: {
                    name: 'chi-tiet-kho',
                    params: { id: phieuXuatKhoDetail.value.id_kho },
                  }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(phieuXuatKhoDetail.value.kho.ten_kho), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : (_unref(formConfig).isManual && khoDetail.value)
                            ? (_openBlock(), _createBlock(BaseLink, {
                                key: 2,
                                to: {
                    name: 'chi-tiet-kho',
                    params: { id: khoDetail.value.id },
                  }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(khoDetail.value.ten_kho), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(DivCol, {
                  "additional-class": "pb-2",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(LabelCustom, {
                        "is-bolder": _unref(formConfig).isManual,
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ngày ")
                        ]),
                        _: 1
                      }, 8, ["is-bolder"]),
                      _createVNode(_component_el_form_item, {
                        prop: "ngay",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: form.value.ngay,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.ngay) = $event)),
                            class: "w-100",
                            disabled: isFormFieldDisabled.value,
                            format: "DD/MM/YYYY",
                            name: "ngay",
                            placeholder: "Chọn ngày",
                            type: "date",
                            tabindex: FORM_TAB.NGAY,
                            onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue", "disabled", "tabindex"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(DivCol, {
                  "additional-class": "pb-2",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(LabelCustom, {
                        "is-bolder": _unref(formConfig).isManual,
                        "is-required": true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Người nhận hàng ")
                        ]),
                        _: 1
                      }, 8, ["is-bolder"]),
                      _createVNode(_component_el_form_item, {
                        prop: "ten_nguoi_nhan",
                        class: "mb-0 w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            id: "ten_nguoi_nhan-input",
                            modelValue: form.value.ten_nguoi_nhan,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.ten_nguoi_nhan) = $event)),
                            class: "w-100",
                            disabled: isFormFieldDisabled.value,
                            name: "ten_nguoi_nhan",
                            placeholder: "Nhập tên người nhận hàng ...",
                            tabindex: FORM_TAB.NGUOI_NHAN,
                            onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue", "disabled", "tabindex"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(DivCol, {
                  "additional-class": "pb-2",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      (_unref(formConfig).isBbgt)
                        ? (_openBlock(), _createBlock(LabelCustom, {
                            key: 0,
                            "is-bolder": _unref(formConfig).isManual
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" BBGT số ")
                            ]),
                            _: 1
                          }, 8, ["is-bolder"]))
                        : (_openBlock(), _createBlock(LabelCustom, {
                            key: 1,
                            "is-bolder": _unref(formConfig).isManual,
                            "is-required": true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Số biên bản ")
                            ]),
                            _: 1
                          }, 8, ["is-bolder"])),
                      (_unref(formConfig).isBbgt)
                        ? (_openBlock(), _createBlock(BaseLink, {
                            key: 2,
                            to: bbgtDetailLink.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(bbgtSoBienBanDisplay.value), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            prop: "so_bien_ban",
                            class: "mb-0 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: form.value.so_bien_ban,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.so_bien_ban) = $event)),
                                class: "w-100",
                                disabled: isFormFieldDisabled.value,
                                name: "so_bien_ban",
                                tabindex: FORM_TAB.SO_BIEN_BAN,
                                onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                              }, null, 8, ["modelValue", "disabled", "tabindex"])
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(formConfig).showTaiKhoan)
              ? (_openBlock(), _createBlock(DivRow, {
                  key: 0,
                  class: "mb-3 g-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(DivCol, {
                      "additional-class": "pb-2",
                      cols: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(LabelCustom, {
                            "is-bolder": _unref(formConfig).isManual,
                            "is-required": true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Lý do ")
                            ]),
                            _: 1
                          }, 8, ["is-bolder"]),
                          _createVNode(_component_el_form_item, {
                            prop: "ly_do",
                            class: "mb-0 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: form.value.ly_do,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.ly_do) = $event)),
                                class: "w-100",
                                disabled: isFormFieldDisabled.value,
                                name: "ly_do",
                                type: "textarea",
                                autosize: { minRows: 1 },
                                resize: "none",
                                tabindex: FORM_TAB.LY_DO,
                                onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.select()))
                              }, null, 8, ["modelValue", "disabled", "tabindex"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(DivCol, {
                      "additional-class": "pb-2",
                      cols: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(LabelCustom, {
                            "is-bolder": _unref(formConfig).isManual
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Tài khoản nợ ")
                            ]),
                            _: 1
                          }, 8, ["is-bolder"]),
                          _createVNode(TaiKhoanSelectionV2, {
                            class: "w-100",
                            "read-only": _unref(formConfig).isManual ? !editableTaiKhoan.value : false,
                            "ma-tai-khoan-prop": 
                    _unref(tkData).maTaiKhoan ? parseInt(_unref(tkData).maTaiKhoan) : undefined
                  ,
                            "ma-chi-tiet-prop": 
                    _unref(tkData).maChiTiet ? _unref(tkData).maChiTiet : undefined
                  ,
                            "ten-tai-khoan-prop": _unref(tkData).tenTaiKhoan,
                            "start-tab-index": FORM_TAB.TK_NO,
                            onOnClear: _unref(clearTaiKhoanData),
                            onOnSelect: _unref(onSelectTaiKhoan)
                          }, null, 8, ["read-only", "ma-tai-khoan-prop", "ma-chi-tiet-prop", "ten-tai-khoan-prop", "start-tab-index", "onOnClear", "onOnSelect"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(ResponsiveLayout, {
                  key: 1,
                  "has-two-columns": "",
                  "margin-y": "my-3"
                }, {
                  "col-1": _withCtx(() => [
                    _createVNode(LabelCustom, {
                      "is-bolder": _unref(formConfig).isManual,
                      "is-required": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Lý do ")
                      ]),
                      _: 1
                    }, 8, ["is-bolder"])
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "ly_do",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.ly_do,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.ly_do) = $event)),
                          disabled: isFormFieldDisabled.value,
                          name: "ly_do",
                          autosize: { minRows: 2 },
                          resize: "none",
                          type: "textarea",
                          tabindex: FORM_TAB.LY_DO,
                          onFocus: _cache[9] || (_cache[9] = ($event: any) => ($event.target.select()))
                        }, null, 8, ["modelValue", "disabled", "tabindex"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ]),
          (_unref(formConfig).isBbgt && (isBbgtCreate.value || phieuXuatKhoDetail.value))
            ? (_openBlock(), _createBlock(_unref(PhieuXuatKhoSuppliesSection), {
                key: 0,
                ref_key: "suppliesSectionRef",
                ref: suppliesSectionRef,
                "hide-kho-selector": "",
                "id-bien-ban": bbgtIdForForm.value,
                "exclude-id-phieu-xuat": isBbgtEdit.value ? idPhieuXuat.value : undefined,
                "initial-kho-id": 
            isBbgtEdit.value ? phieuXuatKhoDetail.value?.id_kho : idKhoFromQuery.value
          ,
                "initial-vat-tu-items": 
            isBbgtEdit.value ? phieuXuatKhoDetail.value?.vat_tu_xuat_kho : undefined
          ,
                "is-edit-mode": isBbgtEdit.value,
                "loai-dinh-muc": loaiDinhMuc.value,
                "loai-phieu": _unref(formConfig).loaiPhieu,
                "show-ly-do-column": _unref(formConfig).showLyDoColumn,
                "show-thu-hoi-columns": _unref(formConfig).showThuHoiColumns,
                "onUpdate:vatTuItems": onVatTuItemsUpdate
              }, null, 8, ["id-bien-ban", "exclude-id-phieu-xuat", "initial-kho-id", "initial-vat-tu-items", "is-edit-mode", "loai-dinh-muc", "loai-phieu", "show-ly-do-column", "show-thu-hoi-columns"]))
            : _createCommentVNode("", true),
          (_unref(formConfig).isManual)
            ? (_openBlock(), _createBlock(_unref(PhieuXuatKhoSuppliesSection), {
                key: 1,
                ref_key: "suppliesSectionRef",
                ref: suppliesSectionRef,
                "id-kho": idKho.value,
                "initial-vat-tu-items": vatTuXuatKhoItems.value,
                "loai-phieu": _unref(formConfig).loaiPhieu,
                readonly: !editable.value && !_unref(isCreating),
                "show-ly-do-column": _unref(formConfig).showLyDoColumn,
                "show-thu-hoi-columns": _unref(formConfig).showThuHoiColumns,
                "onUpdate:vatTuItems": onVatTuItemsUpdate
              }, null, 8, ["id-kho", "initial-vat-tu-items", "loai-phieu", "readonly", "show-ly-do-column", "show-thu-hoi-columns"]))
            : _createCommentVNode("", true),
          (_unref(formConfig).isManual || isBbgtEdit.value || _unref(formConfig).isBbgt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (isFormEdit.value)
                  ? (_openBlock(), _createBlock(ButtonCustom, {
                      key: 0,
                      "button-type": _unref(ButtonsType).CANCEL,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (
              _unref(router).push({
                name: 'chi-tiet-phieu-xuat-kho',
                params: { idPhieuXuatKho: idPhieuXuat.value },
              })
            ))
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Hủy chỉnh sửa")
                      ]),
                      _: 1
                    }, 8, ["button-type"]))
                  : _createCommentVNode("", true),
                _createVNode(ButtonCustom, {
                  "button-type": _unref(ButtonsType).SAVE,
                  "color-type": _unref(ButtonTypeColors).SUCCESS,
                  onClick: handleSubmit
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode(_toDisplayString(isFormEdit.value
                ? "Lưu chỉnh sửa"
                : _unref(formConfig).isBbgt
                ? "Tạo phiếu xuất"
                : "Lưu"), 1)
                  ]),
                  _: 1
                }, 8, ["button-type", "color-type"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }))
}
}

})